import * as React from 'react';
import { ReactNode } from 'react';
import { cn } from '../../utils/cn';
import { selectMenuVariants } from './styles';

export interface SelectMenuProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Menu items (SelectOption components)
   */
  children: ReactNode;
  /**
   * ID for testing
   */
  dataTestId?: string;
}

export const SelectMenu = React.forwardRef<HTMLDivElement, SelectMenuProps>(
  ({ children, className, dataTestId = 'select-menu', ...props }, ref) => {
    return (
      <div
        ref={ref}
        role="listbox"
        className={cn(selectMenuVariants(), 'max-h-[420px] overflow-y-auto', className)}
        data-testid={dataTestId}
        {...props}>
        {children}
      </div>
    );
  }
);

SelectMenu.displayName = 'SelectMenu';
